export const statusMapping = {
  Unknown: {
    label: 'Unknown',
    color: {
      main: '#000000',
      sub: '#E2E2E2',
    },
  },
  SUBMITTED: {
    label: 'Belum Dipacking',
    color: {
      main: '#4285F4',
      sub: '#D9E7FD',
    },
  },
  CONFIRMED: {
    label: 'Dipacking',
    color: {
      main: '#FBA63C',
      sub: '#FFF2E2',
    },
  },
  SHIPPED: {
    label: 'Dikirim',
    color: {
      main: '#FBBC05',
      sub: '#FEF2CD',
    },
  },
  COMPLETED: {
    label: 'Selesai',
    color: {
      main: '#34A770',
      sub: '#DCF3EB',
    },
  },
  CANCELLED: {
    label: 'Dibatalkan',
    color: {
      main: '#E31A1A',
      sub: '#FFEDED',
    },
  },
}

export const MARKETPLACE_PLATFORM = {
  tokopedia: {
    logo: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/tokopedia-logo.png',
    label: 'Tokopedia',
  },
  shopee: {
    logo: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/shopee-logo.png',
    label: 'Shopee',
  },
  lazada: {
    logo: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/lazada-logo.png',
    label: 'Lazada',
  },
  tiktok: {
    logo: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg',
    label: 'TikTok Shop',
  },
  kompack: {
    logo: 'https://storage.googleapis.com/komerce/icon/Vector.svg',
    label: 'Kompack',
  },
}
